module.exports = __webpack_public_path__ + "img/us_xhs.584933a.png";